"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useQuestionSelectionActions = require("../../hooks/questionnaire/useQuestionSelectionActions");
var _r10SourceLibrary = require("r10-source-library");
var _r10CommonComponents = require("r10-common-components");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const mapChoices = choices => {
  const imagePickerOptions = [];
  choices.forEach((choice, index) => {
    const option = {
      id: `image-picker-item-${index}`,
      title: choice.text,
      value: choice.text
    };
    (choice === null || choice === void 0 ? void 0 : choice.image) && imagePickerOptions.push({
      ...option,
      image: {
        alt: choice.text,
        src: choice.image
      }
    });
  });
  return {
    imagePickerOptions
  };
};
const QuestionWithImages = _ref => {
  let {
    question,
    selections
  } = _ref;
  const {
    maxSelections
  } = question;
  const isSelected = choice => selections.includes(choice.text);
  const {
    addSelection,
    removeSelection,
    replaceSelection,
    checkDefaultChoice
  } = (0, _useQuestionSelectionActions.useQuestionSelectionActions)(question);
  const hasDefault = question.choices.some(choice => choice.isDefault);
  (0, _react.useEffect)(() => {
    if (!selections.length) checkDefaultChoice();
  }, [question]);
  const shouldRemoveSelection = choice => {
    return isSelected(choice) && (!hasDefault || hasDefault && selections.length > 1);
  };
  const getSelectedChoice = choiceText => {
    return question.choices.find(choice => choice.text === choiceText);
  };
  const handleSelectedChoiceRemoval = choice => {
    if (shouldRemoveSelection(choice)) {
      removeSelection(choice.text);
    }
  };
  const handleSelectedChoiceAddition = choice => {
    if (maxSelections === 1) {
      replaceSelection(choice.text);
      return;
    }
    handleExclusiveSelections(choice);
    if (!maxSelections || selections.length < maxSelections) {
      addSelection(choice.text);
    }
  };
  const handleExclusiveSelections = currentChoice => {
    question.choices.filter(c => c.text !== currentChoice.text && c.exclusive !== currentChoice.exclusive && isSelected(c)).forEach(c => removeSelection(c.text));
  };
  const onSelectionClick = e => {
    const selectedChoice = getSelectedChoice(e.target.value);
    if (isSelected(selectedChoice)) {
      handleSelectedChoiceRemoval(selectedChoice);
    } else {
      handleSelectedChoiceAddition(selectedChoice);
    }
  };
  const {
    imagePickerOptions
  } = mapChoices(question.choices);
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "question-with-image"
  }, imagePickerOptions.length !== 0 && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10CommonComponents.ImagePickerItem, {
    onChange: onSelectionClick,
    selected: selections,
    label: question.title,
    groupName: 'Default',
    items: imagePickerOptions,
    columns: {
      sm: 2,
      md: 4,
      lg: 4
    }
  }))));
};
var _default = QuestionWithImages;
exports.default = _default;